import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setComponentToShow } from "@store/ModalToShow";
import ModalView from "@modals/modalview/ModalView";
import styles from "./EditPhoneNumber.module.css";
import { setIsdCode, setMobileNumber } from "@store/login/LoginStore";

function EditPhoneNumber({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) {
      const [phoneNumber, setPhoneNumber] = useState("");
        const [countryCode, setCountryCode] = useState("+91");
    const dispatch=useDispatch();
    const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value.replace(/\D/g, ""); // prevents alphabets
        setPhoneNumber(value);
        dispatch(setIsdCode(countryCode));
        dispatch(setMobileNumber(value));
        localStorage.setItem("phoneNumber", value);
        localStorage.setItem("countryCode", countryCode);
        localStorage.setItem(
          "phoneData",
          JSON.stringify({ dialCode: countryCode, number: value })
        );
      };

      const handleNext=()=>{
        dispatch(setComponentToShow("SendOtp"))
      }

  return (
    <ModalView isOpen={isOpen} onClose={onClose}>
      <div className={styles.EditPhoneNumberContainer}>
        <div className={styles.editHeader}>
          <h2>Edit Phone Number</h2>
          <button className={styles.closeBtn} onClick={onClose}>
            &times;
          </button>
        </div>
        <div>
          <select
            value={countryCode}
            className={styles.dial_code_select}
            onChange={(e) => setCountryCode(e.target.value)}
          >
            <option value="+91">+91</option>
          </select>

          <input
            type="tel"
            className={styles.mobile_number_input}
            placeholder="Enter your mobile number"
            onChange={handlePhoneChange}
            value={phoneNumber}
            maxLength={10}
          />
        </div>
        <div>
          <button
            className={styles.nextButton}
            disabled={phoneNumber.length != 10}
            onClick={handleNext}
          >
            NEXT
          </button>
        </div>
      </div>
    </ModalView>
  );
}

export default EditPhoneNumber;
